<template>
    <div>
        <div class="banner"></div>
        <div class="container">
            <el-row :gutter="20">
                <el-col :span="8">
                    <el-card class="tzgg" shadow="hover">
                        <div slot="header">
                            <span style="font-size:18px;">通知公告</span>
                        </div>
                        <div class="titleStyle" v-for="(item,index) in tzData" :key="index" @click="goDetail(item)">
                            <div class="icon"><i class="el-icon-document"></i></div>
                            <div class="wordClass">{{ item.noticeTitle }}</div>
                            <div class="time">{{ item.createTime }}</div>
                        </div>
                    </el-card>
                </el-col>
                <el-col :span="16">
                    <el-card :body-style="{ padding: '0px' }" shadow="hover">
                        <div slot="header" class="cardTtile">
                            <div class="titleBox">
                                <div class="titleZh">企业简介</div>
                                <div class="titleEn">INTRODUCE</div>
                            </div>
                            <el-button @click="$router.push({path:'/profile',query:{page: '21'}})" style="padding: 3px 0" type="text">MORE+</el-button>
                        </div>
                        <div class="cardContent">
                            <div class="cardImg">
                                <img width="100%" src="../assets/images/about-p.jpg" class="image">
                            </div>
                            <div class="cardWord">
                                连云港格润环保科技有限公司（以下简称“格润环保”）成立于2020年4月，总部位于中国首批沿海开放城市、新亚欧大陆桥经济走廊首个节点城市-连云港市，公司现有灌云、海州两处办公地点。公司是一家崇尚创新、追求极致、满怀理想、奋发拼搏的环保咨询公司，格润环保是由江苏省环保系统资深专家、具有丰富市场人脉资源行业领军人等多人初创。
                            </div>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
            <el-row :gutter="20" style="padding-top:20px" class="mainCard">
                    <el-col :span="8">
                        <el-card class="box-card" shadow="hover">
                            <div slot="header" class="cardTtile">
                                <div class="titleBox">
                                    <div class="titleZh">公众参与</div>
                                    <div class="titleEn">PUBLIC</div>
                                </div>
                                <el-button @click="$router.push({path:'/publicity',query:{page: 31}})" style="padding: 3px 0" type="text">MORE+</el-button>
                            </div>
                            <div class="titleStyle" v-for="(item,index) in pubicData" @click="goDetail(item)">
                                <div class="icon"><i class="el-icon-document"></i></div>
                                <div class="wordClass">{{ item.noticeTitle }}</div>
                                <div class="time">{{ item.createTime }}</div>
                            </div>
                        </el-card>
                    </el-col>
                    <el-col :span="8">
                        <el-card class="box-card" shadow="hover">
                            <div slot="header" class="cardTtile">
                                <div class="titleBox">
                                    <div class="titleZh">全本公示</div>
                                    <div class="titleEn">COMPLETE</div>
                                </div>
                                <el-button @click="$router.push({path:'/publicity',query:{page: 32}})" style="padding: 3px 0" type="text">MORE+</el-button>
                            </div>
                            <div class="titleStyle" v-for="(item,index) in completeData" @click="goDetail(item)">
                                <div class="icon"><i class="el-icon-document"></i></div>
                                <div class="wordClass">{{ item.noticeTitle }}</div>
                                <div class="time">{{ item.createTime }}</div>
                            </div>
                        </el-card>
                    </el-col>
                    <el-col :span="8">
                        <el-card class="box-card" shadow="hover">
                            <div slot="header" class="cardTtile">
                                <div class="titleBox">
                                    <div class="titleZh">人才招聘</div>
                                    <div class="titleEn">REQUITMENT</div>
                                </div>
                                <el-button @click="$router.push({path:'/contact'})" style="padding: 3px 0" type="text">MORE+</el-button>
                            </div>
                            <div class="titleStyle" v-for="(item,index) in requitmentData" @click="goDetail(item)">
                                <div class="icon"><i class="el-icon-document"></i></div>
                                <div class="wordClass">{{ item.noticeTitle }}</div>
                                <div class="time">{{ item.createTime }}</div>
                            </div>
                        </el-card>
                    </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import moment from "moment"
export default {
    data() {
        return {
            tzData: [
                // {
                //     title: '关于推荐固体废物属性鉴别机构的通知',
                //     time: '2020-05-18',
                //     url: '',
                // },
                // {
                //     title: '关于推荐固体废物属性鉴别机构的通知',
                //     time: '2020-05-18',
                //     url: '',
                // },
                // {
                //     title: '关于推荐固体废物属性鉴别机构的通知',
                //     time: '2020-05-18',
                //     url: '',
                // },
                // {
                //     title: '关于推荐固体废物属性鉴别机构的通知',
                //     time: '2020-05-18',
                //     url: '',
                // },
            ],
            pubicData: [
                // {
                //     title: '关于推荐固体废物属性鉴别机构的通知',
                //     time: '2020-05-18',
                //     url: '',
                // },
                // {
                //     title: '关于推荐固体废物属性鉴别机构的通知',
                //     time: '2020-05-18',
                //     url: '',
                // },
                // {
                //     title: '关于推荐固体废物属性鉴别机构的通知',
                //     time: '2020-05-18',
                //     url: '',
                // },
                // {
                //     title: '关于推荐固体废物属性鉴别机构的通知',
                //     time: '2020-05-18',
                //     url: '',
                // },
                // {
                //     title: '关于推荐固体废物属性鉴别机构的通知',
                //     time: '2020-05-18',
                //     url: '',
                // },
            ],
            completeData: [],
            requitmentData: [],
        }
    },
    mounted(){
        this.getData(2, 1, 4, 23)
        this.getData(2, 1, 5, 21)
        this.getData(2, 1, 5, 22)
        this.getData(1, 1, 5)
    },
    methods: {
        async getData(noticeType, pageNum, pageSize, parentType){
            var data = {
                noticeType,
                pageNum,
                pageSize,
                parentType
            }
            const { data: res } = await this.$autPost(data,this.$getDataUrl)
            if (res.rows.length > 0) {
                res.rows.forEach(val => {
                    val.createTime = moment(val.createTime).format('YYYY-MM-DD')
                });
                if (parentType === 23) {
                    this.tzData = res.rows
                } else if (parentType === 21) {
                    this.pubicData = res.rows
                } else if (parentType === 22) {
                    this.completeData = res.rows
                } else {
                    this.requitmentData = res.rows
                }
            }
        },
        goDetail(item){
            this.$router.push({
                path:'/detail',
                query:{
                    id:item.id
                },
            })
        },
    },
}
</script>

<style scoped>
    .banner {
        width: 1400px;
        margin: 0 auto;
        background: url(../assets/images/banner.jpg);
        height: 410px;
        background-size: 100% 100%;
    }
    @media screen and (max-width: 1366px){
        .banner {
            width: 100%;
        }
    }
    .cardTtile {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .titleBox {
        display: flex;
        align-items: baseline;
    }
    .titleZh {
        /* padding-left: 15px; */
        font-size: 18px;
        color: #49a8f8;
        font-weight: bold;
    }
    .titleEn {
        padding-left: 20px;
        font-size: 12px;
        color: #9e9e9e;
    }
    .cardContent {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .cardImg {
        width: 49%;
        font-size: 0;
    }
    .cardWord {
        width: 49%;
        padding: 0 14px;
        text-align: justify;
    }
    .titleStyle {
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
        padding: 10px 0;
        border-bottom: 1px dashed #DCDFE6;
    }
    .titleStyle:hover .wordClass{
        text-decoration: underline;
    }
    .wordClass {
        width: 72%;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
    .time {
        width: 21%;
        font-size: 14px;
        color: #909399;
    }
</style>